/**
  * Auswahl-Aufgabe: Single Choice, Multiple Choice oder Verkettung.
  * @namespace v3sWbtPlayerApp:exercise:choice
  */

/**
 * Definiert Modell einer Antwort für MC, SC und CC.
 * @class service_v3sAnswerElement
 * @memberOf v3sWbtPlayerApp:exercise:choice
 */
angular.module('v3sWbtPlayerApp').factory('v3sAnswerElement', ["v3sExerciseService", "v3sExerciseElement", function (v3sExerciseService, v3sExerciseElement) {
    var v3sAnswerElement = function (id) {
        this.id = id;
        this.correctAnswer = false;
        this.userAnswer = false;
        this.status = this.STATUS.SILENT_CORRECT;
        //this.status = this.STATUS.NO_ANSWER;
        this.type = v3sExerciseService.getExerciseType();
        this.load();
    };

    // Create nue v3sExerciseElement
    v3sAnswerElement.prototype = new v3sExerciseElement();

    v3sAnswerElement.prototype.setCorrectAnswer = function (answer) {
        this.correctAnswer = answer;
        if (!!answer && !this.userAnswer) {
            this.status = this.STATUS.NO_ANSWER;
        }
    };

    v3sAnswerElement.prototype.getCorrectAnswer = function () {
        return this.correctAnswer;
    };

    v3sAnswerElement.prototype.hasCorrectAnswer = function () {
        return this.correctAnswer;
    };

    v3sAnswerElement.prototype.setUserAnswer = function (answer) {
        this.userAnswer = answer;
        this.checkAnswer();
    };

    v3sAnswerElement.prototype.checkAnswer = function () {
        if (!this.correctAnswer && !this.userAnswer) {
            this.status = this.STATUS.SILENT_CORRECT;
        } else if (this.correctAnswer && !this.userAnswer) {
            this.status = this.STATUS.NO_ANSWER;
        } else if (!this.correctAnswer && this.userAnswer) {
            this.status = this.STATUS.FALSE;
        } else {
            this.status = this.STATUS.CORRECT;
        }

        this.save();
    };

    return v3sAnswerElement;
}]);
